export default __webpack_public_path__ + "static/media/item7.920d9a83.jpg";